import './Numerology.scss';
import LooksOneOutlinedIcon from '@mui/icons-material/LooksOneOutlined'; // Lucky Number Finder
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined'; // Chinese Lucky Number
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined'; // Life Path Number
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'; // Unlucky Number
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined'; // Destiny Number
// Birth or Root Number
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';

// Soul Urge Number
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';

// Name Number
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';

// Balance Number
import BalanceOutlinedIcon from '@mui/icons-material/BalanceOutlined';

// Lo Shu Grid Analysis
import GridOnOutlinedIcon from '@mui/icons-material/GridOnOutlined';

// Kua Number
import CompassCalibrationOutlinedIcon from '@mui/icons-material/CompassCalibrationOutlined';

import SummarizeIcon from '@mui/icons-material/Summarize';

import { Link } from 'react-router-dom';

const Numerology = ({ onClose }) => {
  return (
    <div className="Numerology-modal-overlay" onClick={onClose}>
      <div className="Numerology-modal-content" onClick={e => e.stopPropagation()}>
        <div className="numerology-container">
          <h2>Numerology</h2>
          <div className="numerology-grid">

            <Link to="/numerology/luckynum" className="numerology-item">
              <LooksOneOutlinedIcon className="icon" />
              <div><h4>Lucky Number Finder</h4></div>
            </Link>

            <Link to="/numerology/chinese-lucky" className="numerology-item">
              <LanguageOutlinedIcon className="icon" />
              <div><h4>Chinese Lucky Number</h4></div>
            </Link>

            <Link to="/numerology/life-path" className="numerology-item">
              <TimelineOutlinedIcon className="icon" />
              <div><h4>Life Path Number</h4></div>
            </Link>

            <Link to="/numerology/unlucky" className="numerology-item">
              <ReportProblemOutlinedIcon className="icon" />
              <div><h4>Unlucky Number</h4></div>
            </Link>

            <Link to="/numerology/destiny" className="numerology-item">
              <ExploreOutlinedIcon className="icon" />
              <div><h4>Destiny Number</h4></div>
            </Link>

            <Link to="/numerology/destiny" className="numerology-item">
              <CakeOutlinedIcon className="icon" />
              <div><h4>Birth or Root Number</h4></div>
            </Link>

            <Link to="/numerology/birth" className="numerology-item">
              <FavoriteBorderOutlinedIcon className="icon" />
              <div><h4>Soul Urge Number</h4></div>
            </Link>

            <Link to="/numerology/name" className="numerology-item">
              <BadgeOutlinedIcon className="icon" />
              <div><h4>Name Number</h4></div>
            </Link>

            <Link to="/numerology/balance" className="numerology-item">
              <BalanceOutlinedIcon className="icon" />
              <div><h4>Balance Number</h4></div>
            </Link>

            <Link to="/numerology/lo-shu-grid" className="numerology-item">
              <GridOnOutlinedIcon className="icon" />
              <div><h4>Lo Shu Grid Analysis</h4></div>
            </Link>

            <Link to="/numerology/kua" className="numerology-item">
              <CompassCalibrationOutlinedIcon className="icon" />
              <div><h4>Kua Number</h4></div>
            </Link>

           <Link to="/numerology/personalyear" className="numerology-item">
              <CompassCalibrationOutlinedIcon className="icon" />
              <div><h4>Personal Number</h4></div>
            </Link>

            <Link to="/numerology/report" className="numerology-item">
              <SummarizeIcon className="icon" />
              <div><h4>Numerology Report</h4></div>
            </Link>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Numerology;
